import React from "react";
import { MockedProvider } from "@apollo/client/testing";
import { GET_CLIENT_AND_INVITATION_WORKERS } from "../../graphql/client";
import { buildWorkerInfo } from "../factories";
import type { Meta, StoryObj } from "@storybook/react";
import ClientWorkersScreen from "../../screens/client/Workers";

const StoryComponent = () => {
    const mocks = [
        {
            request: {
                query: GET_CLIENT_AND_INVITATION_WORKERS,
                variables: {},
            },
            newData: () => ({
                data: {
                    getClientWorkers: [
                        buildWorkerInfo({
                            id: "worker-profile-1",
                        }),
                    ],
                    allInvitations: {
                        __typename: "InvitationPagination",
                        count: 1,
                        elements: [
                            {
                                __typename: "Invitation",
                                id: "invitation-1",
                                phoneNumber: "+41799998877",
                                createdAt: "2020-12-01T00:00:00.000Z",
                                token: "token-1",
                                senderName: "User One",
                                clientName: "Client One",
                                clientLogoUrl: "",
                                text: "Invitation text",
                                mode: "sender",
                                firstName: "User",
                                lastName: "One",
                            },
                        ],
                    },
                },
            }),
        },
    ];
    return (
        <MockedProvider mocks={mocks}>
            {/* @ts-expect-error Stack Component need a complex navigation handler */}
            <ClientWorkersScreen />
        </MockedProvider>
    );
};

const meta = {
    title: "Screens/ClientWorkers",
    component: StoryComponent,
    argTypes: {},
} satisfies Meta<typeof StoryComponent>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {};
